import {
  postRequest
} from "@/api/http";

const loginNameReg = /^[a-zA-Z][a-zA-Z0-9]{3,14}$/; //用户名验证，长度在4-15位的字母或数字,且必须为字母开头
const passwordReg = /^[\w]{6,20}$/; //密码验证，长度在6-20位的字母或数字或下划线
const EmailReg = /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/; //邮箱验证
const mobileReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/; //手机号验证
const idcardReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/; //身份证验证
let password = "",
  rePassword = "";

export const validamobileoginName = (rule, value, callback) => {
  if (value === "" || value == null) {
    callback(new Error("请输入注册账号"));
  }

  if (!loginNameReg.test(value)) {
    callback(new Error("长度在4-15位的字母或数字,且必须为字母开头"));
  } else {
    postRequest("SupplierLogin/ValidateLoginName", {
      loginName: value
    }).then(res => {
      if (res.data.errcode == 0) {
        callback();
      } else {
        callback(new Error(res.data.errmsg));
      }
    });
  }
};

export const validatePass = (rule, value, callback) => {
  password = value;
  if (value === "" || value == null) {
    callback(new Error("请输入密码"));
  }
  if (!passwordReg.test(value)) {
    callback(new Error("长度在6-20位的字母或数字或下划线"));
  } 
  else{
    callback();
  }
  // else if (rePassword !== "") {
  //   if (value !== rePassword) {
  //     callback(new Error("两次输入密码不一致!"));
  //   } else {
  //     callback();
  //   }
  // }
};

export const validatePass2 = (rule, value, callback) => {
  rePassword = value;
  if (value === "" || value == null) {
    callback(new Error("请再次输入密码"));
  } else if (value !== password) {
    callback(new Error("两次输入密码不一致!"));
  } else {
    callback();
  }
};

export const validateEmail = (rule, value, callback) => {
  if (value === "" || value == null) {
    callback(new Error("请输入电子邮箱"));
  }
  if (!EmailReg.test(value)) {
    callback(new Error("请输入正确的邮箱格式"));
  } else {
    callback();
  }
};

export const validatemobile = (rule, value, callback) => {
  if (value === "" || value == null) {
    callback(new Error("请输入手机号码"));
  }
  if (!mobileReg.test(value)) {
    callback(new Error("请输入正确的手机号格式"));
  } else {
    postRequest("SupplierLogin/ValidateMobile", {
      mobile: value
    }).then(res => {
      if (res.data.errcode == 0) {
        callback();
      } else {
        callback(new Error(res.data.errmsg));
      }
    });
  }
};

export const validateSocialCreditCode = (rule, value, callback) => {
  if (value === "" || value == null) {
    callback(new Error("请输入社会信用代码"));
  }

  postRequest("SupplierLogin/ValidateSocialCreditCode", {
    socialCreditCode: value
  }).then(res => {
    if (res.data.errcode == 0) {
      callback();
    } else {
      callback(new Error("该社会信用代码已被用于注册"));
    }
  });

};


export const validatemobile1 = (rule, value, callback) => {
  if (value === "" || value == null) {
    callback(new Error("请输入手机号码"));
  }
  if (!mobileReg.test(value)) {
    callback(new Error("请输入正确的手机号格式"));
  } else {
    callback();
  }
};


export const validateIdCard = (rule, value, callback) => {
  if (value === "" || value == null) {
    callback(new Error("请输入证件号"));
  }
  if (!idcardReg.test(value)) {
    callback(new Error("请输入正确的证件号"));
  } else {
    postRequest("SupplierLogin/ValidateSocialCreditCode", {
      socialCreditCode: value
    }).then(res => {
      if (res.data.errcode == 0) {
        callback();
      } else {
        callback(new Error("该证件已被用于注册"));
      }
    });
  }
};


export const validateIdCard1 = (rule, value, callback) => {
  if (value === "" || value == null) {
    callback(new Error("请输入证件号"));
  }

  postRequest("SupplierLogin/ValidateSocialCreditCode", {
    socialCreditCode: value
  }).then(res => {
    if (res.data.errcode == 0) {
      callback();
    } else {
      callback(new Error("该证件已被用于注册"));
    }
  });
};

export const validateIdCar2 = (rule, value, callback) => {
  if (value === "" || value == null) {
    callback(new Error("请输入证件号"));
  }
  if (!idcardReg.test(value)) {
    callback(new Error("请输入正确的证件号"));
  } else {
    callback();
  }
};

export const validContact = (rule, value, callback) => {
  if (value === "" || value == null) {
    callback(new Error("请输入联系人名称"));
  }
  else {
    var len = 0;
    for (var i = 0; i < value.length; i++) {
      var a = value.charAt(i);
      if (a.match(/[^\x00-\xff]/ig) != null) {
        len += 2;
      } else {
        len += 1;
      }
    }
    if (len > 10) {
      console.log(len)
      callback(new Error("请输入不大于5个中文字符或10英文字符"));
    }
    else {
      callback();
    }
  }



};